import React from 'react'
import { get } from 'lodash'
import { ReactTable, amsSelectionColumn, searchVehicle } from '../../feature-react-table'
import { useSearchVehiclesDmsFeedDetailLazyQuery } from '../generated/graphql'
import type { SearchCardDetailProps } from '../types'

const {
    accessors: { account, consignorStockNumber, daysOnLot, floorAmount, makeModelYearIsNew, odometer, vinLastSix },
    Cells: { Account, MakeModelYearCellWithAsset },
} = searchVehicle

const columns = [
    amsSelectionColumn,
    {
        Header: 'Vehicle',
        accessor: makeModelYearIsNew,
        Cell: MakeModelYearCellWithAsset,
        width: 28,
    },
    {
        Header: 'VIN',
        accessor: vinLastSix,
        width: 10,
    },
    {
        Header: 'Account',
        accessor: account,
        Cell: Account,
        width: 28,
    },
    {
        Header: 'Days on Lot',
        accessor: daysOnLot,
        width: 8,
    },
    {
        Header: 'Odometer',
        accessor: odometer,
        width: 10,
    },
    {
        Header: 'Floor',
        accessor: floorAmount,
        width: 8,
    },
    {
        Header: 'Account Stock',
        accessor: consignorStockNumber,
        width: 8,
    },
]

const mobileColumns = [
    amsSelectionColumn,
    {
        Header: 'Vehicle',
        accessor: makeModelYearIsNew,
        Cell: MakeModelYearCellWithAsset,
    },
    {
        Header: 'VIN',
        accessor: vinLastSix,
    },
]

export const SearchVehiclesDMSFeedDetailComponent: React.VFC<SearchCardDetailProps> = ({
    searchString,
    title,
}: SearchCardDetailProps) => {
    return (
        <ReactTable
            shareMetaData={{ shareSubject: 'Vehicles' }}
            columns={columns}
            mobileColumns={mobileColumns}
            queryOptions={{ variables: { searchString } }}
            lazyQueryHook={useSearchVehiclesDmsFeedDetailLazyQuery}
            countPath="auction.search.vehicleCount"
            listPath="auction.search.vehicleResult"
            sendToAMSPath="assetId"
            title={({ res }): string => title || get(res, 'auction.search.searchStringDisplay', 'Search Results')}
        />
    )
}

export const searchVehicleDMSFeedColumns = columns
export const searchVehicleDMSFeedMobileColumns = mobileColumns
